import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const ResolveSupportNotificationModal = ({
    isOpen,
    onClose,
    onConfirm,
}) => {
    return (
        <ReusableModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Resolve Support Request"
            bodyMessage={
                <>
                    Are you sure this customer support request has been{" "}
                    <strong>resolved</strong>?
                    <br />
                    <br />
                    Please ensure the issue has been addressed in the Support Messages section before proceeding.
                    This action will mark the notification as read and remove it from the pending support queue.
                </>
            }
            confirmLabel="Resolve"
            cancelLabel="Cancel"
        />
    );
};

export default ResolveSupportNotificationModal;